import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '../../../../elements/Link';
import {
  StyledFooterLocations,
  StyledFooterLocationsHeader,
  StyledFooterLocationsList,
  StyledFooterLocationsListItem,
  StyledFooterLocationsMoreLink,
} from './styles';

const DS_FooterLocations = ({ label, items, moreLink }) => {
  return (
    <StyledFooterLocations>
      <StyledFooterLocationsHeader>
        <Typography variant="DS_copyBigBold">{label}</Typography>
      </StyledFooterLocationsHeader>
      <StyledFooterLocationsList>
        {items.map(item => (
          <StyledFooterLocationsListItem key={item.id}>
            <Link url={item.url} type={item.type}>
              {item.title}
            </Link>
          </StyledFooterLocationsListItem>
        ))}
        <StyledFooterLocationsMoreLink>
          <Typography component={Link} url={moreLink.url} variant="DS_copySmallBold">
            {moreLink.title}
          </Typography>
        </StyledFooterLocationsMoreLink>
      </StyledFooterLocationsList>
    </StyledFooterLocations>
  );
};

export default DS_FooterLocations;
